import UAParser from 'ua-parser-js'

const UAP = new UAParser()
const os = UAP.getOS()
const device = UAP.getDevice()
const ua = navigator.userAgent.toLowerCase()

const isAndroid = () => os && os.name === 'Android'
const isIOS = () => os && os.name === 'iOS'
const isApple = () => /ip(hone|od|ad)/i.test(ua)
const isWechat = () => !!~ua.indexOf('micromessenger')
const getEnv = () => {
  const env_wx = window.__wxjs_environment === 'miniprogram' || !!~ua.indexOf('alipayclient')
  return env_wx
}

export default {
  device,
  isWechat: isWechat(),
  isAndroid: isAndroid(),
  isIOS: isIOS(),
  isApple: isApple(),
  getEnv
}
